<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
          <div class="">
             <img class="p-4" src="@/assets/images/academy/whatis.svg"/>
          </div>
        </LessonTabContent>
      </tab-content>


      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>
             <youtube class="track-ai-video mt-4" video-id="Gine8ahNaDY" :player-width="playerWidth"></youtube>
        </LessonTabContent>
      </tab-content>
    </form-wizard>
  </LessonContent>
</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    LessonTabContent,
    TabContent,
    FormWizard
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
    playerWidth () {
      return this.$store.getters.isMobile ? 350 : 500
    }
  },
  methods: {
  },
}
</script>
